import { render, staticRenderFns } from "./ReferenceIndexPage.vue?vue&type=template&id=32115d6c"
import script from "./ReferenceIndexPage.vue?vue&type=script&lang=js"
export * from "./ReferenceIndexPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports